// extracted by mini-css-extract-plugin
module.exports = {"ionItem":"style_ionItem__369yM","ionLabel":"style_ionLabel__23yJ6","barwisFileName":"style_barwisFileName__y2_lZ","barwisFileCreatedAt":"style_barwisFileCreatedAt__Qbz-_"};